import { Context, Controller } from '@hotwired/stimulus';
import { emit } from 'src/emitter';

export default class ScriptLineNumbersLinksController extends Controller {
  static targets = [];
  static values = {
    wakeword: String,
  };

  declare wakewordValue: string;
  private scriptTarget: HTMLTextAreaElement | null | undefined;

  constructor(context: Context) {
    super(context);
  }

  public connect(): void {
    super.connect();

    const children = this.element.children;
    const length = children.length;

    for (let i = 0; i < length; i++) {
      const child = children.item(i);
      if (child?.textContent?.includes(this.wakewordValue)) {
        this.linkify(child);
      }
    }

    this.scriptTarget = document.querySelector<HTMLTextAreaElement>(
      'textarea[data-target="script-line-numbers-links-target"]',
    );
  }

  private linkify(child: Element) {
    console.log('[script-line-numbers]', child);
    if (!(child instanceof HTMLElement)) {
      return;
    }

    const index = child.innerHTML.indexOf(this.wakewordValue);
    if (index === -1) {
      return;
    }

    const matched = child.innerHTML
      .substring(index + this.wakewordValue.length)
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
    let endIndex = matched.indexOf(';');

    if (endIndex === -1) endIndex = matched.indexOf('.');
    if (endIndex === -1) endIndex = matched.indexOf(':');
    if (endIndex === -1) endIndex = matched.length;

    const number = Number(matched.substring(0, endIndex));
    const replaceable = `${this.wakewordValue}${number}`;

    child.innerHTML = child.innerHTML.replace(
      replaceable,
      `<button
        type="button"
        data-action="script-line-numbers-links#go"
        data-script-line-numbers-links-go-param="${number}"
        class="decoration-pink-500 hover:underline-offset-2 hover:bg-pink-500 hover:text-white underline transition decoration-wavy"
      >${replaceable}</button>`,
    );
  }

  public go(event: Event & { params?: { go?: number } }) {
    if (!Object.prototype.hasOwnProperty.call(event, 'params')) {
      return;
    }

    const lineNumber = event.params!.go;
    if (lineNumber === undefined) {
      return;
    }

    if (!this.scriptTarget) {
      emit('script:line:go', { for: this.wakewordValue, n: lineNumber });
      return;
    }

    const lines = this.scriptTarget.value.split('\n');
    const position = lines
      .slice(0, lineNumber - 1)
      .reduce((total, line) => total + line.length + 1, 0);

    this.scriptTarget.setSelectionRange(position, position);
    this.scriptTarget.focus();
  }
}
